// 五金叫料弹窗
export const hardwareColumns = [
  { title: '工厂', dataIndex: 'organizationName', ellipsis: true, width: 120, align: 'center' },
  { title: '工单号', dataIndex: 'notifyWipEntityName', ellipsis: true, width: 140, align: 'center' },
  { title: '原材料编码', dataIndex: 'notifyRawMaterialCode', width: 120, ellipsis: true, align: 'center' },
  { title: '原材料名称', dataIndex: 'rawMaterialName', width: 120, align: 'center', ellipsis: true },
  { title: '单位', dataIndex: 'uom', width: 80, align: 'center' },
  { title: '未叫料', dataIndex: 'unCallQty', width: 90, align: 'center' },
  { title: '可叫料数', dataIndex: 'canCallQty', width: 85, align: 'center' },
  {
    // title: '叫料量',
    dataIndex: 'callQty',
    width: 100,
    align: 'center',
    scopedSlots: { customRender: 'callQty', title: "callQtyTitle" },
    type: "inputNumber"
  },
  {
    // title: '指定批次号',
    dataIndex: 'lotNo',
    width: 150,
    scopedSlots: { customRender: 'lotNo', title: "lotNoTitle" },
    align: 'center'
  },
  {
    title: '色号&色差',
    dataIndex: 'colorNumDiff',
    ellipsis: true,
    width: 120,
    scopedSlots: { customRender: 'colorNumDiff' },
    align: 'center'
  },
  {
    title: '要求送达时间',
    dataIndex: 'lastSupplyDate',
    width: 120,
    scopedSlots: { customRender: 'lastSupplyDate' },
    align: 'center'
  },
  {
    title: '备注',
    scopedSlots: { customRender: 'remark' },
    dataIndex: 'remark',
    width: 150,
    align: 'center'
  },
  {
    title: '操作',
    width: 100,
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
    align: 'center',
    fixed: 'right'
  }
]

// 皮布叫料
export const fabricColumns = [
  { title: '工厂', dataIndex: 'organizationName', ellipsis: true, width: 120, align: 'center' },
  { title: '工单号', dataIndex: 'notifyWipEntityName', ellipsis: true, width: 140, align: 'center' },
  { title: '原材料编码', dataIndex: 'notifyRawMaterialCode', width: 120, ellipsis: true, align: 'center' },
  { title: '原材料名称', dataIndex: 'rawMaterialName', width: 120, align: 'center', ellipsis: true },
  { title: '单位', dataIndex: 'uom', width: 80, align: 'center' },
  { title: '未叫料', dataIndex: 'unCallQty', width: 90, align: 'center' },
  {
    // title: '叫料量',
    dataIndex: 'callQty',
    width: 100,
    align: 'center',
    scopedSlots: { customRender: 'callQty', title: "callQtyTitle" },
    type: "inputNumber"
  },
  {
    // title: '指定批次号',
    dataIndex: 'lotNo',
    width: 150,
    scopedSlots: { customRender: 'lotNo', title: "lotNoTitle" },
    align: 'center'
  },
  {
    title: '色号&色差',
    dataIndex: 'colorNumDiff',
    ellipsis: true,
    width: 120,
    scopedSlots: { customRender: 'colorNumDiff' },
    align: 'center'
  },
  {
    title: '要求送达时间',
    dataIndex: 'lastSupplyDate',
    width: 120,
    scopedSlots: { customRender: 'lastSupplyDate' },
    align: 'center'
  },
  {
    title: '备注',
    scopedSlots: { customRender: 'remark' },
    dataIndex: 'remark',
    width: 150,
    align: 'center'
  },
  {
    title: '操作',
    width: 100,
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
    align: 'center',
    fixed: 'right'
  }
]
